(function () {

    const original_show = frappe.ui.Dialog.prototype.show;

    frappe.ui.Dialog.prototype.show = function () {

        original_show.apply(this, arguments);

        setTimeout(() => {

            // Find "With Letter head" checkbox
            let field = this.fields_dict?.with_letterhead;

            if (field && !field.get_value()) {

                field.set_value(1);
            }

        }, 100);
    };

})();

